<template>
  <div>
    <div>
      <i class="fa fa-folder fa-3 color-blue" aria-hidden="true"></i>
      <span class="cs-course-name" @click="onClick">{{name}}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.fa-3 {
  font-size: 2.5em;
}
.color-blue {
  color: #5dc0e4;
}
.cs-course-name {
  vertical-align: super;
  cursor: pointer;
  margin-left: 0.5em;
}
</style>

<script>
export default {
  props: {
    data: {},
  },
  data() {
    return {
      name: "",
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!!this.data) {
        this.name = this.data.CourseFullName;
      }
    },
    onClick() {
      let data = {
        action: "view",
        data: this.data,
      };
      this.$emit("customEvent", data);
    },
  },
  watch: {
    data: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/appointmentCourseNameCell.vue